import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled, { keyframes, css } from 'styled-components';
import { SuccessIcon, ErrorIcon, WarningIcon, InfoIcon } from './utils/IconFactory';
import Button from './Button';
const resources = {
    plain: {
        icon: null,
        bgColor: 'var(--notifications-background)'
    },
    success: {
        icon: SuccessIcon,
        bgColor: 'var(--ui-color-green)'
    },
    warning: {
        icon: WarningIcon,
        bgColor: 'var(--ui-color-orange)'
    },
    error: {
        icon: ErrorIcon,
        bgColor: 'var(--ui-color-red)'
    },
    info: {
        icon: InfoIcon,
        bgColor: 'var(--ui-accent-color)'
    }
};
let notifier = null;
let closer = null;
export let notifications = [];
function Notification({ type, text, html = '', layout = 'row', onClose, action, className }) {
    const resource = resources[type];
    const Icon = resource.icon;
    return (_jsxs(NotificationWrap, { className: className, layout: layout, onClick: onClose, type: type, bgColor: resource.bgColor, children: [type !== 'plain'
                && _jsx(Icon, { width: 24, height: 24, style: { marginRight: 16 }, fill: "white" }), _jsxs("div", { className: "content", style: { flexDirection: layout }, children: [_jsx("div", { className: "content_text", children: type === 'error' ? text.split(';').join(', ') : text }), typeof html === 'string' && html
                        ? _jsx("div", { className: "content_html", dangerouslySetInnerHTML: { __html: html } })
                        : _jsx("div", { className: "content_node", children: html }), action
                        ? _jsx(Button, { className: "action", size: 'small', color: 'accent', bordered: true, onClick: evt => {
                                action.fn({ type, layout, evt });
                            }, children: _jsx("span", { children: action.title }) })
                        : null] })] }));
}
const modalFadeIn = keyframes `
  from {
    opacity: 0;
    transform: translateY(2em);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
`;
const NotificationWrap = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;

  ${props => props.layout === 'column' && css `
    align-items: flex-start;
  `}

  border-radius: 0.375rem;
  box-shadow: 0 0 0.313rem rgba(0, 0, 0, 0.5);
  padding: 0.75em 1em;
  margin-bottom: 1em;
  white-space: nowrap;
  cursor: pointer;
  user-select: none;
  background-color: ${props => props.bgColor};

  color: var(--ui-color-white);

  ${props => props.type === 'plain' && css `
    color: var(--text-secondary);
  `}

  animation: ${modalFadeIn} 0.1s ease-out;

  .content {
    display: flex;
    flex-direction: column;
    flex: 1;
    align-items: center;

    * + * {
      margin-left: 0.875rem;
    }

    ${props => props.layout === 'column' && css `
      align-items: flex-start;
      margin-top: 0.5rem;
    `}

    &_text {
      flex: 1;
      align-items: center;
      
      ${props => props.layout === 'column' && css `
        align-items: flex-start;
      `}
    }

    &_html,
    &_node {
      flex: 1;

      a {
        color: var(--accent-blue);

        &:hover {
          text-decoration: none;
        }
      }
    }
  }
`;
export default function Notifications({ className = '' }) {
    const [, setCounter] = React.useState(0);
    const forceUpdate = () => setCounter(Date.now());
    notifier = ({ type = 'info', text = '', html = '', action, timeout = 3000, closable = true, key }) => {
        if (key && notifications.find(n => n.key === key)) {
            return null;
        }
        const id = Date.now();
        const timer = closable && timeout ? window.setTimeout(() => {
            onClose(id);
        }, timeout) : -1;
        notifications.push({
            id,
            timer,
            type,
            text,
            html: html !== null && html !== void 0 ? html : '',
            action,
            key,
            closable
        });
        forceUpdate();
    };
    closer = (key) => {
        const n = notifications.find(n => n.key === key);
        if (n) {
            onClose(n.id);
            forceUpdate();
        }
    };
    const onClose = (id) => {
        clearTimeout(notifications
            .find(n => n.id === id).timer);
        notifications = notifications
            .filter(n => n.id !== id);
        forceUpdate();
    };
    return (_jsx(NotificationsC, { className: `${className} ui-notifications`, children: notifications
            .map(n => _jsx(Notification, { type: n.type, layout: n.layout, onClose: n.closable ? () => onClose(n.id) : () => { }, text: n.text, html: n.html, action: n.action }, n.id)) }));
}
const NotificationsC = styled.div `
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 0;
  left: 50%;
  bottom: 0;
  z-index: 1000;
`;
export function show(opts) {
    if (notifier) {
        notifier(opts);
    }
}
export function hide(key) {
    if (closer) {
        closer(key);
    }
}
